
const GENERICS = Object.freeze({
  ID: 'id',
  ADD: 'add',
  EDIT: 'edit',
  VIEW: 'view',
  STATUS: 'status',
  OPTION_ID: 'optionId',
  ADD_OPTION: 'add-option',
  EDIT_OPTION: 'edit-option'
});

export {
  GENERICS
};
